export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '焦点专题', href: '#carousel' },
  { label: '热门排行', href: '#ranking' },
  { label: '精彩视频', href: '#media' },
  { label: '联系我们', href: '#contact' },
];

export const heroData = {
  tags: ['每日更新', '高清画质', '海量片库'],
  h1: '91麻豆免费视频网站 · 综合性影视在线观看平台',
  slogan: '随时随地，畅享精彩影视内容',
  intro: '91麻豆免费视频网站致力于打造国内领先的综合性在线视频平台，汇聚91年国产影片视频、91传媒视频在线、91精彩视频在线观看等丰富频道资源。网站每日更新海量热门影视内容，涵盖电影、电视剧、综艺、动漫等全品类节目，支持高清流畅在线播放。无论您是追剧达人还是电影爱好者，这里都能满足您的观影需求，让您足不出户畅享视听盛宴。当前平台正持续扩展国产影片专区，新增多部经典与最新国产佳作，为观众带来原汁原味的中文影视体验。',
  stats: [
    { value: '10万+', label: '影视资源' },
    { value: '每日更新', label: '持续上新' },
    { value: '全高清', label: '画质标准' },
  ],
  primaryCta: { label: '开始观影', href: '#carousel' },
  secondaryCta: { label: '热门排行', href: '#ranking' },
};

export const topics = [
  { tag: '国产剧热播', heat: '128.6万热度', href: '#carousel', color: 'primary' },
  { tag: '最新综艺', heat: '96.3万热度', href: '#media', color: 'accent' },
  { tag: '院线大片', heat: '87.5万热度', href: '#cards', color: 'primary' },
  { tag: '经典重温', heat: '74.2万热度', href: '#index', color: 'secondary' },
  { tag: '悬疑推理', heat: '65.8万热度', href: '#ranking', color: 'accent' },
  { tag: '古装传奇', heat: '59.4万热度', href: '#carousel', color: 'primary' },
  { tag: '动漫番剧', heat: '52.1万热度', href: '#cards', color: 'secondary' },
  { tag: '都市情感', heat: '48.7万热度', href: '#index', color: 'accent' },
  { tag: '科幻巨制', heat: '43.2万热度', href: '#ranking', color: 'primary' },
  { tag: '纪录片', heat: '38.9万热度', href: '#media', color: 'secondary' },
];

export const carouselItems = [
  {
    title: '国产影片精选',
    subtitle: '百部经典与最新佳作一次性放送',
    desc: '从九十年代至今，精选国产影片佳片，涵盖文艺、喜剧、动作等多种类型，原汁原味的中文影视体验。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20red%20and%20gold%20accents%2C%20film%20strip%20motif%2C%20Chinese%20movie%20poster%20inspired%20layout%2C%20dramatic%20lighting%2C%20elegant%20and%20artistic%20background%20with%20soft%20gradients&width=800&height=480&seq=carousel-01&orientation=landscape',
  },
  {
    title: '传媒原创剧集',
    subtitle: '独家自制内容全程高能',
    desc: '91传媒出品原创系列剧集，情节紧凑制作精良，每周定时更新，剧情扣人心弦不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20film%20scene%20with%20warm%20amber%20lighting%2C%20cinematic%20texture%2C%20overlapping%20geometric%20shapes%2C%20sophisticated%20entertainment%20visual%2C%20rich%20coral%20and%20gold%20tones&width=800&height=480&seq=carousel-02&orientation=landscape',
  },
  {
    title: '热门影视在线',
    subtitle: '全网最热影视一网打尽',
    desc: '追踪全平台热度榜单，整合当下最受欢迎的电视剧、综艺和网络节目，精品内容每日更新不断档。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20background%20with%20glowing%20light%20streaks%2C%20film%20texture%2C%20elegant%20dark%20backdrop%20with%20golden%20accents%2C%20luxurious%20entertainment%20aesthetic&width=800&height=480&seq=carousel-03&orientation=landscape',
  },
  {
    title: '年度综艺盛典',
    subtitle: '爆笑与感动齐飞的综艺盛宴',
    desc: '汇集年度最热门综艺节目，从真人秀到脱口秀，从音乐竞技到生活体验，综艺迷的快乐老家。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20entertainment%20stage%20lighting%20composition%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20soft%20bokeh%20effects%2C%20festive%20and%20lively%20atmosphere%2C%20artistic%20show%20visual&width=800&height=480&seq=carousel-04&orientation=landscape',
  },
  {
    title: '动漫番剧专区',
    subtitle: '热血与治愈伴你每一刻',
    desc: '国产动漫与日漫番剧精选合集，从热血战斗到温馨日常，持续更新最新番剧，动漫爱好者聚集地。',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20abstract%20illustration%20with%20flowing%20energy%20lines%2C%20warm%20orange%20and%20gold%20hues%2C%20motion%20blur%20effect%2C%20vibrant%20and%20youthful%20aesthetic%2C%20entertainment%20visual%20style&width=800&height=480&seq=carousel-05&orientation=landscape',
  },
  {
    title: '纪录片档案馆',
    subtitle: '用镜头探索世界的真相',
    desc: '自然、历史、科技、人文多维度纪录片资源库，高清画质深度内容，满足求知欲与探索精神。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20cinematic%20abstract%20with%20earthy%20warm%20tones%2C%20documentary%20style%20texture%2C%20soft%20natural%20light%20gradient%2C%20sophisticated%20and%20educational%20aesthetic&width=800&height=480&seq=carousel-06&orientation=landscape',
  },
];

export const cards = [
  {
    title: '《长安三万里》全片上线',
    desc: '国产动画巨制震撼登陆，诗意大唐画卷徐徐展开，高清画质沉浸体验，带您穿越千年感受盛唐风华。',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20Chinese%20ink%20painting%20style%20landscape%20with%20warm%20golden%20light%2C%20ancient%20Chinese%20architecture%20silhouette%2C%20dreamy%20atmosphere%2C%20elegant%20cultural%20visual&width=640&height=400&seq=card-01&orientation=landscape',
    tag: '国产动画',
  },
  {
    title: '《狂飙》全集限时重温',
    desc: '年度现象级剧集回归，张颂文张译飙戏教科书级别表演，扫黑题材巅峰之作，值得反复品味的经典。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20with%20dramatic%20contrast%2C%20urban%20night%20aesthetic%2C%20warm%20spotlight%20effect%2C%20intense%20drama%20visual%2C%20film%20noir%20inspired&width=640&height=400&seq=card-02&orientation=landscape',
    tag: '热播剧集',
  },
  {
    title: '《乘风破浪》最新季',
    desc: '姐姐们再次集结，舞台炸裂全场，话题不断引爆社交媒体，综艺迷不可错过的视听盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20stage%20performance%20abstract%2C%20colorful%20dynamic%20light%20beams%2C%20energetic%20atmosphere%2C%20warm%20pink%20and%20gold%20tones%2C%20show%20biz%20aesthetic&width=640&height=400&seq=card-03&orientation=landscape',
    tag: '热门综艺',
  },
  {
    title: '《三体》剧版震撼回归',
    desc: '科幻巨制第二季强势来袭，宇宙级视觉奇观，硬核科幻与人文思考完美融合，国产科幻新标杆。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20abstract%20cosmic%20scene%2C%20deep%20space%20with%20warm%20nebula%20colors%2C%20sci-fi%20aesthetic%2C%20mysterious%20and%20grand%20visual%2C%20cinematic%20space%20art&width=640&height=400&seq=card-04&orientation=landscape',
    tag: '科幻巨制',
  },
  {
    title: '《隐秘的角落》导演新作',
    desc: '悬疑大师再出手，层层反转烧脑升级，每一个镜头都暗藏玄机，国产悬疑剧新天花板。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20abstract%20composition%20with%20shadow%20and%20light%20contrast%2C%20warm%20%20amber%20mood%2C%20suspenseful%20atmosphere%2C%20artistic%20thriller%20visual%2C%20elegant%20dark%20aesthetic&width=640&height=400&seq=card-05&orientation=landscape',
    tag: '悬疑力作',
  },
  {
    title: '《向往的生活》完结篇',
    desc: '蘑菇屋最后一季温情落幕，黄磊何炅携老友重聚，田园慢生活治愈人心，温馨告别满满回忆杀。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20pastoral%20abstract%20scene%2C%20soft%20sunlight%20through%20trees%2C%20cozy%20countryside%20aesthetic%2C%20golden%20hour%20glow%2C%20peaceful%20and%20healing%20visual&width=640&height=400&seq=card-06&orientation=landscape',
    tag: '治愈综艺',
  },
];

export const faqItems = [
  {
    q: '91麻豆免费视频网站提供哪些类型的影视内容？',
    a: '平台提供电影、电视剧、综艺、动漫、纪录片等多种类型，涵盖91年国产影片视频、91传媒视频在线等多个精品频道，类型丰富满足不同观影需求。',
  },
  {
    q: '91精彩视频在线观看需要注册账号吗？',
    a: '平台提供便捷的在线观看服务，基础内容无需注册即可直接观看。注册会员可享受收藏同步、观看历史等更多个性化功能，观影体验更加贴心。',
  },
  {
    q: '影视网站免费观看的内容更新频率如何？',
    a: '平台每日更新大量最新影视资源，热门影视在线同步主流平台播出节奏。国产剧、综艺等热门内容一般在播出后24小时内更新，确保观众第一时间收看到精彩内容。',
  },
  {
    q: '在线视频平台支持哪些设备观看？',
    a: '91麻豆免费视频网站全面支持电脑端、平板端、手机端等多种设备在线观看，界面自动适配不同屏幕尺寸。同时推出移动端APP，随时随地畅享高清影视内容。',
  },
  {
    q: '91传媒视频在线的画质怎么样？',
    a: '平台全线采用全高清及以上画质标准，91传媒视频在线频道更是采用超清画质技术，确保每一帧画面都清晰细腻，为观众带来影院级的视觉享受。',
  },
];

export const features = [
  {
    icon: 'ri-movie-2-line',
    title: '海量片库',
    desc: '汇聚10万+影视资源，覆盖91年国产影片视频、热门影视在线、91精彩视频在线观看等全品类内容，每日持续更新扩充片库容量。',
  },
  {
    icon: 'ri-4k-line',
    title: '全高清画质',
    desc: '全线采用全高清及以上标准，91传媒视频在线频道更配备超清技术，多码流自适应播放确保流畅观影体验，画质与速度兼得。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定',
    desc: '采用先进的视频加密与传输技术保障播放安全，91美女视频网站等频道设有严格的年龄验证机制，为用户营造绿色健康的在线视频平台环境。',
  },
];

export const rankingItems = [
  { rank: 1, title: '《繁花》沪语版全集', heat: '本周热度 986.5万', tag: '热播', href: '#carousel' },
  { rank: 2, title: '《大江大河3》最新更新', heat: '本周热度 872.3万', tag: '新剧', href: '#cards' },
  { rank: 3, title: '《中国好声音》年度总决赛', heat: '本周热度 765.8万', tag: '综艺', href: '#media' },
  { rank: 4, title: '《流浪地球3》独家首播', heat: '本周热度 698.4万', tag: '电影', href: '#carousel' },
  { rank: 5, title: '《长相思》第二季大结局', heat: '本周热度 621.7万', tag: '热播', href: '#cards' },
  { rank: 6, title: '《密室大逃脱》新一季开播', heat: '本周热度 554.2万', tag: '综艺', href: '#media' },
  { rank: 7, title: '《孤注一掷》海外票房突破', heat: '本周热度 489.6万', tag: '电影', href: '#ranking' },
];

export const indexItems = [
  { title: '91国产影片专区', desc: '经典国产老片与最新佳作', icon: 'ri-film-line', href: '#carousel' },
  { title: '91传媒原创频道', desc: '独家自制剧集持续更新', icon: 'ri-tv-2-line', href: '#cards' },
  { title: '热门影视在线', desc: '全网热度榜单实时追踪', icon: 'ri-fire-line', href: '#ranking' },
  { title: '综艺欢乐集结', desc: '爆笑综艺陪你度过每一天', icon: 'ri-emotion-laugh-line', href: '#media' },
  { title: '动漫二次元', desc: '热血与治愈的动漫世界', icon: 'ri-rocket-line', href: '#cards' },
  { title: '纪录片频道', desc: '自然历史科技深度内容', icon: 'ri-earth-line', href: '#index' },
  { title: '悬疑推理馆', desc: '烧脑反转高分悬疑佳作', icon: 'ri-search-eye-line', href: '#ranking' },
];

export const appData = {
  title: '91麻豆APP · 掌上观影更便捷',
  desc: '下载91麻豆免费视频网站官方APP，随时随地畅享高清影视。支持离线缓存、个性化推荐、弹幕互动等丰富功能，让观影体验无处不在。适配iOS与安卓系统，安装即用，操作流畅。',
  features: ['离线缓存随时看', '智能推荐懂你口味', '弹幕互动更有趣', '投屏电视大屏看'],
  image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20abstract%20cinematic%20interface%2C%20warm%20coral%20and%20dark%20theme%2C%20clean%20minimal%20design%2C%20app%20screen%20with%20video%20content%20layout%2C%20elegant%20tech%20aesthetic&width=600&height=520&seq=app-01&orientation=portrait',
};

export const updates = [
  { date: '2026-07-31', title: '《繁花》沪语版全集正式上线91精彩视频在线观看频道', tag: '上新' },
  { date: '2026-07-29', title: '91传媒视频在线频道推出暑期档国产影片连播活动', tag: '活动' },
  { date: '2026-07-27', title: '热门影视在线频道新增AI智能推荐功能，观影体验再升级', tag: '功能' },
  { date: '2026-07-25', title: '在线视频平台移动端APP版本更新至v4.2.0，界面全新改版', tag: '更新' },
  { date: '2026-07-22', title: '91年国产影片视频专区新增50部经典影片修复版本', tag: '上新' },
  { date: '2026-07-20', title: '影视网站免费观看频道播放量突破10亿大关', tag: '里程碑' },
  { date: '2026-07-18', title: '91美女视频网站分区升级安全验证机制，保障绿色观影', tag: '公告' },
  { date: '2026-07-15', title: '与多家影视制作方达成合作，下半年新片版权陆续上线', tag: '合作' },
  { date: '2026-07-12', title: '网站服务器全面升级，播放流畅度提升30%', tag: '公告' },
];

export const mediaItems = [
  {
    title: '《长安三万里》独家幕后花絮',
    desc: '走进国产动画巨制的创作世界',
    duration: '15:42',
    views: '128.6万',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20abstract%20film%20production%20visual%2C%20warm%20studio%20lighting%2C%20creative%20workspace%20atmosphere%2C%20cinematic%20behind%20camera%20aesthetic%2C%20artistic%20documentary%20style&width=640&height=380&seq=media-01&orientation=landscape',
  },
  {
    title: '2026暑期档观影片单推荐',
    desc: '精选暑期必看影视作品合集',
    duration: '08:30',
    views: '95.4万',
    image: 'https://readdy.ai/api/search-image?query=Summer%20movie%20aesthetic%20abstract%2C%20warm%20sunset%20glow%2C%20film%20reel%20motif%2C%20vibrant%20entertainment%20visual%2C%20golden%20hour%20cinematic%20feel&width=640&height=380&seq=media-02&orientation=landscape',
  },
  {
    title: '《三体》视效解析专题片',
    desc: '揭秘国产科幻里程碑的视觉密码',
    duration: '22:18',
    views: '186.2万',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20visual%20effects%20abstract%2C%20cosmic%20particles%20and%20light%20trails%2C%20scifi%20production%20design%2C%20warm%20and%20cool%20color%20contrast%2C%20cinematic%20VFX%20style&width=640&height=380&seq=media-03&orientation=landscape',
  },
  {
    title: '经典国产影片修复对比展',
    desc: '4K修复技术让老电影焕发新生',
    duration: '10:55',
    views: '73.8万',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20restoration%20abstract%2C%20before%20after%20split%20composition%2C%20warm%20nostalgic%20tones%2C%20classic%20cinema%20aesthetic%2C%20film%20preservation%20visual&width=640&height=380&seq=media-04&orientation=landscape',
  },
];

export const aboutData = {
  title: '关于91麻豆免费视频网站',
  paragraphs: [
    '91麻豆免费视频网站成立于2019年，是国内领先的综合性在线视频平台之一。平台以"让每个人都能轻松享受影视乐趣"为使命，经过多年深耕发展，已建立起覆盖91年国产影片视频、91传媒视频在线、91精彩视频在线观看等多元频道的丰富内容生态。',
    '作为优质的影视网站免费观看平台，我们始终坚持以用户为中心，持续优化热门影视在线观看体验。在线视频平台汇聚了超10万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容，每日保持高频更新节奏，确保观众第一时间获取最新精彩内容。',
    '在内容品质上，91传媒视频在线频道建立了严格的选片和制作标准，全线采用全高清及以上画质技术，配合多码流自适应播放系统，为不同网络环境下的用户提供流畅的观影保障。91美女视频网站等特色频道也在不断丰富内容的同时，完善安全防护和内容审核机制。',
    '展望未来，91麻豆免费视频网站将继续加大在内容版权、技术研发和用户体验方面的投入，打造更加智能化、个性化的观影平台，让每一位用户都能在这里找到属于自己的精彩影视世界。',
  ],
};

export const comments = [
  {
    name: '影迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20minimal%20avatar%20warm%20tone%20circle%20style&width=64&height=64&seq=avatar-01&orientation=squarish',
    text: '用了91麻豆一年多了，更新是真的快。繁花刚播完第二天就能看全集了，国产影片专区也很给力，好多老片子修复版画质超棒！',
    time: '2天前',
  },
  {
    name: '追剧达人阿玲',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20minimal%20avatar%20soft%20warm%20tone%20circle%20style&width=64&height=64&seq=avatar-02&orientation=squarish',
    text: '自从发现了91精彩视频在线观看频道，我的追剧生活就停不下来了。画质清晰流畅，资源还特别全，国产剧、综艺、动漫都有，太方便了。',
    time: '5天前',
  },
  {
    name: '电影发烧友老张',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20minimal%20avatar%20earthy%20warm%20tone%20circle%20style&width=64&height=64&seq=avatar-03&orientation=squarish',
    text: '作为一个看了三十年电影的老影迷，91年国产影片视频这个频道让我找到了好多记忆中的老片子，修复后的画质竟然这么好，真心推荐给大家。',
    time: '1周前',
  },
  {
    name: '二次元小七',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20minimal%20avatar%20warm%20vibrant%20tone%20circle%20style&width=64&height=64&seq=avatar-04&orientation=squarish',
    text: '动漫番剧更新速度没得说，追新番就靠91麻豆了。而且弹幕氛围特别好，没有乱七八糟的引战，大家讨论剧情都很认真。',
    time: '1周前',
  },
  {
    name: '综艺迷小雨',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20abstract%20portrait%20minimal%20avatar%20golden%20warm%20tone%20circle%20style&width=64&height=64&seq=avatar-05&orientation=squarish',
    text: '热门影视在线频道的综艺更新太及时了，每次朋友群里讨论最新一集我都能跟上。画质清晰又不卡顿，看综艺的心情都变好了。',
    time: '2周前',
  },
];

export const contactData = {
  title: '联系我们',
  desc: '如果您有任何关于91麻豆免费视频网站的意见、建议或合作意向，欢迎通过以下方式联系我们。我们珍视每一位用户的反馈，将竭诚为您服务。',
  email: 'feedback@91madou.com',
  wechat: '91madou_official',
  qq: '800123456',
  tips: ['意见反馈反馈邮箱通常在24小时内回复', '商务合作请注明公司及合作意向', '内容投稿请附作品简介和联系方式'],
};